module.exports = __webpack_public_path__ + "static/index/assets/img/4.7e3f9ad4.png";